import { createContext } from 'react'

export const AuthContext = createContext({
	initialized: false,
	loggedIn: false,
	userData: null,
	setUserData: () => {}
})